import React from 'react';

const ActionThread = ( ) => (
  <svg
    width='16'
    height='15'
    viewBox='0 0 16 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.88206 5.5V3L4.04492 7.49375L9.88206 11.6875V8.81563C12.4969 8.81563 14.0311 9.09375 15.9999 12C15.9999 12 15.7654 5.5 9.88206 5.5Z'
      fill='white'
      fillOpacity='0.5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 7.49995L5.53721 11.4531V9.62495L2.37639 7.49995L5.53721 5.0437V3.26245L0 7.49995Z'
      fill='white'
      fillOpacity='0.5'
    />
  </svg>
);

export default ActionThread;
